export default __webpack_public_path__ + "static/logo-21ee2728254e9f5b29f72437c11a82b6.svg";